module.exports = __webpack_public_path__ + "static/img/Lachy-Dovaston.b902cd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachy-Dovaston.jpg
// module id = 0FVc
// module chunks = 0